import { render, staticRenderFns } from "./MyGames.vue?vue&type=template&id=848d3770&scoped=true&"
import script from "./MyGames.vue?vue&type=script&lang=js&"
export * from "./MyGames.vue?vue&type=script&lang=js&"
import style0 from "./MyGames.vue?vue&type=style&index=0&id=848d3770&scoped=true&lang=css&"
import style1 from "./MyGames.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848d3770",
  null
  
)

export default component.exports